import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center mt-4" }

import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { saveLink } from '@/../../EshJSLib/services/linkPersonaleServices';
import altroLinkPersonali from "@/../../EshJSLib/models/form/altroLinkPersonali.json";
import altroOspedaliItaliani from "@/../../EshJSLib/models/form/altroOspedaliItaliani.json";
import altroOspedaliEsteri from "@/../../EshJSLib/models/form/altroOspedaliEsteri.json";
import altroLineeGuidaItaliane from "@/../../EshJSLib/models/form/altroLineeGuidaItaliane.json";
import altroLineeGuidaInternazionali from "@/../../EshJSLib/models/form/altroLineeGuidaInternazionali.json";
import altroRisorseWebItaliane from "@/../../EshJSLib/models/form/altroRisorseWebItaliane.json";
import altroRisorseWebInternazionali from "@/../../EshJSLib/models/form/altroRisorseWebInternazionali.json";
import altroRivisteItaliane from "@/../../EshJSLib/models/form/altroRivisteItaliane.json";
import altroRivisteInternazionali from "@/../../EshJSLib/models/form/altroRivisteInternazionali.json";
import { reactive, ref, onMounted } from "vue";
import linkPersonaliCreate from "./linkPersonaliCreate.vue";
import { Link } from "../../../../EshJSLib/models/patient";
import TableRow from './TableRow.vue';
import { getLineGuidaInternazionaleLinks, getOspedaliItalianiLinks, getLineGuidaItalianeLinks, getOspedaliEsteriLinks, getRisorveWebInternazionaleLinks, getRisorveWebItalianeLinks, getRivisteInternazionaliLinks, getRivisteItalianeLinks } from "../../../../EshJSLib/services/altroLinkServices";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { hasPermission } from "../../../../EshJSLib/services/securityServices";
import { useRouter } from "vue-router";
import { Modal } from "flowbite-vue";

//Ref Element with HTML

export default /*#__PURE__*/_defineComponent({
  __name: 'AltroPage',
  setup(__props) {

const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
//const linkPersonaliCreate = ref<InstanceType<typeof linkPersonaliCreate> | null>(null);
const isShownModal = reactive({
    alert: false,
    movePage: false,
    confirm: false,
    alertMove: false,
});
const store = patientStore();
const { patient } = storeToRefs(store);

let isModalOpen = ref(false);
const showLoading = ref(false);
const router = useRouter();


const data = reactive({
  altroRivisteInternazionaliLinks: [],
  altroRivisteItalianeLinks: [],
  altroRisorseWebInternazionaliLinks: [],
  altroRisorseWebItalianeLinks: [],
  altroLineGuidaInternazionaliLinks: [],
  altroLineGuidaItalianeLinks: [],
  altroOspedaliEsteriLinks: [],
  altroOspedaliItalianiLinks: [],
});
onMounted(async () => {
  showLoading.value = true;
  patient.value.links;
  store.fetchLink()
  data.altroRivisteInternazionaliLinks = await getRivisteInternazionaliLinks();
  data.altroRivisteItalianeLinks = await getRivisteItalianeLinks();
  data.altroRisorseWebInternazionaliLinks = await getRisorveWebInternazionaleLinks();
  data.altroRisorseWebItalianeLinks = await getRisorveWebItalianeLinks();
  data.altroLineGuidaInternazionaliLinks = await getLineGuidaInternazionaleLinks();
  data.altroLineGuidaItalianeLinks = await getLineGuidaItalianeLinks();
  data.altroOspedaliEsteriLinks = await getOspedaliEsteriLinks();
  data.altroOspedaliItalianiLinks = await getOspedaliItalianiLinks();
  showLoading.value = false;
})
let indexgl = ref(null);
let newlink = reactive({} as Link);

async function saveAndRefreshLink(userInput: boolean, row: Link) {
  if (userInput) {
    showLoading.value = true;

    saveLink(row).then((x) => {
      store.fetchLink()
      showLoading.value = false;
    }).catch((error) => {
      showLoading.value = false;
      alertModal.value.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false)
    })
  } else {
    store.fetchLink();
  }

}

function movePage() {
  router.push({ path: '/registro/Paypal' })
}


 function addLinkPersonali() {
           
    newlink = reactive({} as Link)
    // indexgl.value = patient.value.links.length;
    // patient.value.links = patient.value.links.concat(reactive(newlink as unknown as Link));
    isModalOpen.value = true;
 
}

function closeModal() {
  // store.refreshScheda(store.patient.id_paziente);
  isModalOpen.value = false;
  //  store.fetchLink()
}

async function action(type: string, row: Link, index: number, table: string) {
  let userInput = false;

  switch (type) {
    case "add":
      // row = {} as Link
      // row.id_link = 0
      // row.id_paziente = patient.value.id_paziente
      // row.status = 'add'
      //userInput = await linkPersonaliCreate.value?.openModal("Crea Link Personale", row);
      //saveAndRefreshLink(userInput, row)

       if (await hasPermission('aggiungialtro')) {
        addLinkPersonali();
      } else {
        isShownModal.alert = true;
      }

      break;
    case 'trash':
      alertModal.value.openModal("Sei sicuro di cancellare il record?", true).then((userInput) => {
        row.status = 'delete'
        saveAndRefreshLink(userInput, row)
      })
      break;
    case "pen":
      if (await hasPermission('modificaaltro')) {
        row.status = 'update'
        userInput = await linkPersonaliCreate.value?.openModal("Modifica Link", row);
        saveAndRefreshLink(userInput, row)
      } else {
        isShownModal.alert = true;
      }
      break;
    case 'eye':
      window.open(row.link);
      break;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CollapsibleItem, {
          data: _unref(altroLinkPersonali),
          onRowActions: _cache[0] || (_cache[0] = (n, r, i) => action(n, r, i, 'links')),
          onCreateForm: _cache[1] || (_cache[1] = ($event: any) => (action('add', null, 0, '0')))
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, { data: _unref(altroOspedaliItaliani) }, {
          default: _withCtx(() => [
            _createVNode(TableRow, {
              data: data.altroOspedaliItalianiLinks,
              showTableHeads: true
            }, null, 8, ["data"])
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(CollapsibleItem, { data: _unref(altroOspedaliEsteri) }, {
          default: _withCtx(() => [
            _createVNode(TableRow, {
              data: data.altroOspedaliEsteriLinks,
              showTableHeads: true
            }, null, 8, ["data"])
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(CollapsibleItem, { data: _unref(altroLineeGuidaItaliane) }, {
          default: _withCtx(() => [
            _createVNode(TableRow, {
              data: data.altroLineGuidaItalianeLinks
            }, null, 8, ["data"])
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(CollapsibleItem, { data: _unref(altroLineeGuidaInternazionali) }, {
          default: _withCtx(() => [
            _createVNode(TableRow, {
              data: data.altroLineGuidaInternazionaliLinks
            }, null, 8, ["data"])
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(CollapsibleItem, { data: _unref(altroRisorseWebItaliane) }, {
          default: _withCtx(() => [
            _createVNode(TableRow, {
              data: data.altroRisorseWebItalianeLinks
            }, null, 8, ["data"])
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(CollapsibleItem, { data: _unref(altroRisorseWebInternazionali) }, {
          default: _withCtx(() => [
            _createVNode(TableRow, {
              data: data.altroRisorseWebInternazionaliLinks
            }, null, 8, ["data"])
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(CollapsibleItem, { data: _unref(altroRivisteItaliane) }, {
          default: _withCtx(() => [
            _createVNode(TableRow, {
              data: data.altroRivisteItalianeLinks
            }, null, 8, ["data"])
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(CollapsibleItem, { data: _unref(altroRivisteInternazionali) }, {
          default: _withCtx(() => [
            _createVNode(TableRow, {
              data: data.altroRivisteInternazionaliLinks
            }, null, 8, ["data"])
          ]),
          _: 1
        }, 8, ["data"]),
        (_unref(isModalOpen) == true)
          ? (_openBlock(), _createBlock(linkPersonaliCreate, {
              key: 0,
              onCancel: closeModal
            }))
          : _createCommentVNode("", true),
        (showLoading.value)
          ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(AlertModal, {
          ref_key: "alertModal",
          ref: alertModal
        }, null, 512),
        (isShownModal.alert)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 2,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (isShownModal.alert = false))
            }, {
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (isShownModal.alert = false)),
                    type: "button",
                    class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                  }, _toDisplayString(_ctx.$t("Annulla")), 1),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (movePage())),
                    type: "button",
                    class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                  }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})